/* eslint-disable no-unused-vars */
import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import _ from 'lodash'
import {
  firebaseConnect,
  isLoaded,
  isEmpty
} from 'react-redux-firebase'

import { isAdmin } from '../../../utils/admin';
import Map from './Map';

export default compose(
  firebaseConnect(props=> {
    // console.log(props.match.params.key)
    const sessionKey = props.match.params.key;
    return [
      'users',
      { path: `/geoFire/${sessionKey}` },
      { path: '/geojson/map_v1/features', storeAs: 'features' },
    ]
  }),
  connect((state, props) =>
  {

    return ({
      sessionKey: props.match.params.key,
      geoFire: state.firebase.data.geoFire,
      features: state.firebase.data.features,
      isAdmin: isAdmin(state.firebase.auth),
    })
  }
)
)(Map)



// WEBPACK FOOTER //
// ./src/components/pages/Edit/index.js